interface ResourceBarProps {
  label: string;
  used: string;
  total: string;
  percent: number;
}

function getBarColor(percent: number): string {
  if (percent > 85) return 'bg-error';
  if (percent > 70) return 'bg-warning';
  return 'bg-success';
}

export function ResourceBar({ label, used, total, percent }: ResourceBarProps) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-text-secondary">
          {label}{' '}
          <span className="text-text-muted">
            {used} / {total}
          </span>
        </span>
        <span className="text-text-primary font-medium">{percent}%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-bg-tertiary">
        <div
          className={`h-2 rounded-full transition-all duration-500 ease-out ${getBarColor(percent)}`}
          style={{ width: `${Math.min(percent, 100)}%` }}
        />
      </div>
    </div>
  );
}

export default ResourceBar;
